
/**
 * Very basic oil capacities per some typical car configs.
 * These are example values for demonstration and can be extended as needed.
 */
const oilCapacityData: Record<
  string,
  Record<string, Record<string, number>>
> = {
  "BMW": {
    "2020": { "Turbocharged": 6.5, "Gasoline": 5.0 },
    "2010": { "Turbocharged": 6.0, "Gasoline": 4.5 }
  },
  "Mercedes-Benz": {
    "2020": { "Diesel": 7.0, "Gasoline": 5.5 },
    "2010": { "Diesel": 6.5, "Gasoline": 5.0 }
  },
  "Toyota": {
    "2020": { "Hybrid": 4.0, "Gasoline": 4.4 },
    "2010": { "Gasoline": 4.1 }
  },
  "Ford": {
    "2020": { "Turbocharged": 5.7, "Gasoline": 5.0 },
    "2010": { "Gasoline": 4.7 }
  }
};

/**
 * Returns oil capacity (in liters) based on car make, year, and engine type
 */
export function getOilCapacityForCar(
  make: string,
  year: string,
  engineType: string
): number {
  if (!make || !year || !engineType) return 4;

  const yearGroup = Object.keys(oilCapacityData[make] || {}).find(y =>
    year.startsWith(y)
  );
  if (
    oilCapacityData[make] &&
    yearGroup &&
    oilCapacityData[make][yearGroup] &&
    typeof oilCapacityData[make][yearGroup][engineType] === "number"
  ) {
    return oilCapacityData[make][yearGroup][engineType];
  }

  // Sensible fallback for unknowns
  if (engineType.toLowerCase().includes("diesel")) return 6;
  if (engineType.toLowerCase().includes("turbo")) return 5.5;
  if (engineType.toLowerCase().includes("hybrid")) return 4;
  return 4.5;
}
